import React from 'react';
import { Button, List } from '@spothero/ui';
import { dropdownElementStyling } from './styles';
export const LinkList = () => {
    return (<List textAlign="left">
            <li>
                <Button {...dropdownElementStyling} href="/get-spothero-app" data-testid={`header-menu-get-app`}>
                    Get the App
                </Button>
            </li>
            <li>
                <Button {...dropdownElementStyling} href="/faq" data-testid={`header-menu-secondary-/faq`}>
                    How it Works
                </Button>
            </li>
            <li>
                <Button {...dropdownElementStyling} href="/about/parking-guarantee" data-testid={`header-menu-secondary-/about/parking-guarantee`}>
                    Parking Guarantee
                </Button>
            </li>
            <li>
                <Button {...dropdownElementStyling} href="/about" data-testid={`header-menu-secondary-/about`}>
                    About SpotHero
                </Button>
            </li>
            <li>
                <Button {...dropdownElementStyling} marginBottom="0" href="/contact" data-testid={`header-menu-secondary-/contact`}>
                    Contact Us
                </Button>
            </li>
        </List>);
};
